// extracted by mini-css-extract-plugin
export default {"adornment":"EndAdornment_adornment__78qu6"};